//
// Works only in chrome and firefox
// Used to get all devices: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/enumerateDevices
// Used to taking photo: https://developer.mozilla.org/en-US/docs/Web/API/ImageCapture/takePhoto
//

<template>
  <div class="camera-view">
    <!-- <Loader v-if="loading" /> -->
    <template ><!-- v-else -->
      	<video 
      		ref     = "video" 
      		class   = "camera-stream"
      		style   = "
      					width : 100%;
      					height: 100%;"


      	/>
      <div class="camera-modal-container"> <!--  v-show="isReady" -->
        <!-- <v-layout justify-center> -->
          <!-- <v-btn
            dark
            fab
            large
            color="pink"
            @click="capture"
          >
            <v-icon>camera</v-icon>
          </v-btn> -->
        <!-- </v-layout> -->
          <!-- v-if="sources.length > 1" -->
        <v-btn
          fixed
          left
          bottom
          small
          dark          
          :color = "capturing ? 'blue' : ''"
          class  = "mb-10 ml-12"
          @click = "capture"
        >
          <!-- @click="switchCamera" -->
          <v-icon
            small
            :color = "capturing ? 'error' : 'secondary'"
            class  = "mr-1"
          >
            mdi-circle
          </v-icon>
          living
          <!-- <v-switch     
              dense           
              false-value
              hide-details
              class       = "mt-1"      
              v-model     = "info[item_info.key]"           
              :label      = "$ml.get(item_info.text)"
              :prepend-icon   = "item_info.icon"
            ></v-switch> -->
        </v-btn>
      </div>
    </template>
    
    <v-btn
      fixed
      right
      bottom
      small
      dark
      class = "mb-10"
      absolute
      color="blue"
    >
      <!-- @click="gotoTask" -->
      <v-icon>liveness</v-icon>
    </v-btn>
  </div>
</template>

<script>

export default {
  props: {
    /*taskId: {
      type: String,
      required: true
    }*/
  },
  data() {
    return {
      initialized: false,
      loading: false,
      mediaStream: null,
      sources: [],
      selectedSource: null,
      capturing : false,
      interval  : null,
      ms        : 10000,
    }
  },
  computed: {
    isReady() {
      return this.initialized && !this.loading
    }
  },
  mounted() {
    const supported = 'mediaDevices' in navigator
    if (!supported) {
    	console.warn("Unfortunately we can't get access to your camera");
      // this.$addError("Unfortunately we can't get access to your camera")
      return
    }
    // console.log()
    this.getDevices()
      .then(this.gotDevices)
      .then(this.getStream)
      .then(this.gotStream)
      .catch(this.handleError)
  },
  destroyed() {
    this.stopStream()
  },
  methods: {
    switchCamera() {
      let nextSourceIndex = 1 + this.sources.indexOf(this.selectedSource)
      if (nextSourceIndex >= this.sources.length) {
        nextSourceIndex = 0
      }
      this.selectedSource = this.sources[nextSourceIndex]
      this.getStream().then(this.gotStream)
    },
    gotoTask() {
      // this.$router.push({ name: 'detail', params: { id: this.taskId } })
    },

    blobToBase64(blob) {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    capture() {
      let vm         = this;
      this.capturing = !this.capturing;
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }else{
        vm.interval = setInterval(()=>{

          let mediaStreamTrack = vm.mediaStream.getVideoTracks()[0]
          let imageCapture = new window.ImageCapture(mediaStreamTrack)
          return imageCapture.takePhoto().then(blob => {
            vm.loading = true
            console.log(blob)
            vm.blobToBase64(blob).then(tobase64=>{
                vm.$EventBus.$emit('liveness',{image:tobase64,user: vm.$store.state.auth.user.user.id})
            })
          })
        }, vm.ms)
      }
    },
    handleError(error) {
    	console.warn("Error ---- > ", error)
      //this.$addError(error)
    },
    async getDevices() {
    	await navigator.mediaDevices.getUserMedia({audio: true, video: true});
    	console.log("getDevices }}}}}}}}}}}}}}}}}}}}}}}}}}}}} ", await navigator.mediaDevices.enumerateDevices())
      return await navigator.mediaDevices.enumerateDevices()
    },
    gotDevices(devices) {
      this.sources = []
      devices.forEach(device => {
        if (device.kind === 'videoinput') {
          this.sources.push(device)
        }
      })
      if (!this.sources.length) {
        throw 'There are no video sources found!'
      }
      if (!this.selectedSource) {
        this.selectedSource = this.sources[0]
      }
    },
    getStream() {
      this.stopStream()
      return navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: { exact: this.selectedSource.deviceId }
        }
      })
    },
    gotStream(mediaStream) {
      this.mediaStream = mediaStream
      this.$refs.video.srcObject = mediaStream
      this.$refs.video.play().then(() => (this.initialized = true))
    },
    stopStream() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop())
      }
    }
  }
}
</script>

<style scoped>
.camera-view {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  position: absolute;
  background-color: rgb(209, 209, 209, 0);
}
.camera-stream {
  width: 100%;
  max-height: 100%;
}
.camera-modal-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  align-items: center;
  margin-bottom: 24px;
}
</style>